import React, { useCallback, useEffect, useRef, useState } from "react";

import { Col, Layout, message, Row } from "antd";

import { smallFormItemLayout, tailFormItemLayout } from "./../../utils/Layouts";

import { useSelector } from "react-redux";

import axios from "axios";
import { sumBy } from "lodash";
import moment from "moment";
import Container from "../../commons/Container";
import FormHeader from "../../commons/FormHeader";
import MemorizeTable from "../../commons/MemorizeTable";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import ReportButtons from "../../commons/ReportButtons";
import {
  authenticateAdmin,
  authenticateOwner,
} from "../../utils/authentications";
import ReportFooter from "../../utils/ReportFooter";
import ReportHeading from "../../utils/ReportHeading";
import numberFormat from "../../utils/numberFormat";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import { onBranchSearch, onWarehouseSearch } from "../../utils/utilities";
import { onChange } from "../../utils/form_utilities";

const { Content } = Layout;

const url = "/api/sales/";
const title = "Sales Channel Sales Per Period Covered";

const initialValues = {
  period_covered: [moment().startOf("day"), moment().endOf("day")],
  branches: [],
  is_excel: false,
};
export default function SalesChannelSalesPerPeriodCovered({
  other_set = false,
  history,
}) {
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);
  const [trans_types, setTransType] = useState([]);
  const [loading, setLoading] = useState({
    search: false,
    download: false,
  });
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
    purchase_orders: [],
    warehouses: [],
  });
  const report = useRef(null);

  const getReport = useCallback(({ ...form_data }) => {
    if (form_data.period_covered) {
      setLoading({
        search: !form_data.is_excel,
        download: form_data.is_excel,
      });
      axios
        .post(`${url}sales-channel-sales-per-period-covered`, form_data)
        .then((response) => {
          if (response.data) {
            if (form_data.is_excel) {
              return window.open(`/public/reports/${response.data.filename}`);
            }
            setRecords(response.data.records);
            setTransType(response.data.trans_types);
          }
        })
        .catch((err) => {
          message.error("There was an error processing your request");
        })
        .finally(() => {
          setLoading({
            search: false,
            download: false,
          });
        });
    } else {
      message.warning("Period Covered is Required");
    }
  }, []);

  useEffect(() => {
    let authenticate = other_set ? authenticateOwner : authenticateAdmin;

    authenticate({
      role: auth.user?.role,
      history,
    });
  }, [auth.user]);

  return (
    <Content style={{ padding: "0 50px" }}>
      <FormHeader breadcrumb_items={["Reports", title]} />
      <Container title={title}>
        <Row>
          <Col span={12}>
            <RangeDatePickerFieldGroup
              label="Period Covered"
              name="period_covered"
              value={state.period_covered}
              onChange={(dates) =>
                setState((prevState) => ({
                  ...prevState,
                  period_covered: dates,
                }))
              }
              formItemLayout={smallFormItemLayout}
            />
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <SelectTagFieldGroup
              label="Branches"
              value={state.branches}
              onSearch={(value) => {
                onBranchSearch({ value, setOptions });
              }}
              onChange={(value) => {
                onChange({
                  key: "branches",
                  value,
                  setState,
                });
              }}
              formItemLayout={smallFormItemLayout}
              options={(options.branches || []).map((o) => {
                return {
                  label: o.name,
                  value: o.name,
                };
              })}
            />
          </Col>
        </Row>

        <ReportButtons
          loading={loading}
          onSearch={() => getReport({ ...state })}
          onDownload={() => getReport({ ...state, is_excel: true })}
          report={report}
          formItemLayout={tailFormItemLayout}
        />

        <div ref={report}>
          <div className="report-heading">
            <ReportHeading />
            <span className="has-text-weight-bold">{title}</span>
            <br />
            {state.period_covered?.[0] &&
              state.period_covered?.[1] &&
              `${moment(state.period_covered?.[0]).format("ll")} - ${moment(
                state.period_covered?.[1]
              ).format("ll")} `}{" "}
            <br />
            Printed By : {auth.user.name} <br />
            Date/Time Printed : {moment().format("LLL")}
          </div>

          <MemorizeTable dependencies={[records, trans_types]}>
            <div className="report-container">
              <table>
                <thead>
                  <tr>
                    <th rowSpan={2}>DATE</th>
                    {trans_types.map((type) => {
                      return (
                        <th colSpan={2} className="has-text-centered">
                          {type ? type : "ETC."}
                        </th>
                      );
                    })}
                  </tr>
                  <tr>
                    {trans_types.map((type) => {
                      return (
                        <>
                          <th className="has-text-centered">
                            No. of Transactions
                          </th>
                          <th className="has-text-right">Amount</th>
                        </>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {records.map((record, index) => (
                    <tr key={index}>
                      <td className="has-text-centered">{record._id}</td>
                      {trans_types.map((type) => {
                        const items = record.items.filter(
                          (o) => o.trans_type === type
                        );
                        return (
                          <>
                            <td className="has-text-centered">
                              {sumBy(items, (o) =>
                                parseFloat(o?.number_of_transactions || 0)
                              )}
                            </td>
                            <td className="has-text-right">
                              {numberFormat(sumBy(items, (o) => o.amount))}
                            </td>
                          </>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <th />
                    {trans_types.map((type) => {
                      const items = records
                        .flatMap((o) => o.items)
                        .filter((o) => o.trans_type === type);
                      return (
                        <>
                          <th className="has-text-centered">
                            {sumBy(items, (o) =>
                              parseFloat(o?.number_of_transactions || 0)
                            )}
                          </th>
                          <th className="has-text-right">
                            {numberFormat(sumBy(items, (o) => o.amount))}
                          </th>
                        </>
                      );
                    })}
                  </tr>
                </tfoot>
              </table>
            </div>
          </MemorizeTable>

          <div className="report-heading m-t-1">
            <ReportFooter />
          </div>
        </div>
      </Container>
    </Content>
  );
}
